import React from "react";
import {Button, CardContent, Divider, Typography, Box} from "@mui/material";

import {useLocation, useSearchParams} from "wouter";

import {authClient} from "./App.jsx";
import {useConfig} from "./configProvider.js";
import {useTranslation} from "react-i18next";

const Pricing = () => {
    const {t} = useTranslation();
    const [config, setConfig] = useConfig();
    const [location, setLocation] = useLocation();
    const [searchParams] = useSearchParams();
    const product = searchParams.get("product") || null;
    const {data: session} = authClient.useSession();

    const handleCancel = () => {
        setLocation("/");
        }

    return  <CardContent >

                  <Typography variant="h5" fontWeight="bold">{t('Pricing')}</Typography>
        
                    {(config &&  config?.products[product]?.portal) ?

                        <>
                        <script async src="https://js.stripe.com/v3/pricing-table.js"></script>

                        <stripe-pricing-table
                            pricing-table-id={config?.products[product]?.priceTable}
                            publishable-key={config?.stripePublicKey}
                            customer-email={session?.user?.email}
                            />
                        </>
                    :
                    <Box sx={{mt: 2, py: 2}}>
                        <Typography variant="body1">{t("Pricing not available")}</Typography>
                    </Box>
                    }

                <Divider />

                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button onClick={handleCancel} sx={{ml: "auto"}}>{t("Cancel")}</Button>
                </Box>
            </CardContent>;
    }

export default Pricing;